import { updateFeedbackRpc } from '../../__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotMessageService';
import { rpcClient } from '../clients/ChatSpotApi';
export const updateFeedback = requestPayload => {
  return rpcClient.call(updateFeedbackRpc, {
    request: requestPayload
  });
};